export class CurriculumConstants{
    //Top bar title
    public static readonly Curriculum_TopBarTitle :string = "Curriculum";

    // confirmation Messages
    public static readonly Curriculum_Slider_Confirmation_Header: string =
    'Confirmation';
    public static readonly Curriculum_Slider_Confirmation_Text: string =
    'Any unsaved change will be lost when closing the screen. Do you want to continue?';

    //Spinner message
    public static readonly Curriculum_SaveInProgress :  string = 'Curriculum Save is in progress';

    //PlaceHolder
    public static readonly Scope_Tree_Select_PlaceHolder: string = 'eQMS Scope';

    // Toaster Messages and Severity
    public static readonly Severity_Success: string = 'success';
    public static readonly Severity_Info: string = 'info';
    public static readonly Severity_Err: string = 'error';
    public static readonly Severity_Warning: string = 'warn';

    //Tab indicies
    public static readonly Curriculum_Menu_Document_Tab_Index: number = 1;
    public static readonly Curriculum_Menu_Course_Tab_Index: number = 2;

    //Type of training Item
    public static readonly Curriculum_DocumentType: number = 0;
    public static readonly Curriculum_CourseType: number = 1;

    //Status of training Item
    public static readonly Curriculum_StatusActive: number = 0;
    public static readonly Curriculum_StatusNameActive: string = "Active";
    public static readonly Curriculum_StatusRemoved: number = 1;
    public static readonly Curriculum_StatusNameRemoved: string = "Removed";
    public static readonly Curriculum_StatusScheduled: number = 2;
    public static readonly Curriculum_StatusNameScheduled: string = "Scheduled";


    //Core/Elective of training Item
    public static readonly Curriculum_Core: number = 0;
    public static readonly Curriculum_CoreName: string = "Core";
    public static readonly Curriculum_Elective: number = 1;
    public static readonly Curriculum_ElectiveName: string = "Elective";
    public static readonly Curriculum_NotApplicable: number = 2;
    public static readonly Curriculum_NotApplicableName: string = "N/A";

    //Error Messages
    public static readonly AtleastOneTrainingItem_ShouldBeSelected: string = "At least one item must be selected in the search results for addition in the Curriculum.";
    public static readonly LinkedDocument_AlreadyExists_InCurriculum: string = "The following Documents are already in the Curriculum, it is not possible to add them again: DocumentNumbers";
    public static readonly Selected_Documentscopes_Not_Matching_Error_Message: string = "The following Documents cannot be linked to this Curriculum as they are associated with an incompatible eQMS Scope: DocumentNumbers";
    public static readonly LinkedCourse_AlreadyExists_InCurriculum: string = "The following Courses are already in the Curriculum, it is not possible to add them again: CourseNumbers"
    public static readonly Selected_CourseScopes_Not_Matching_Error_Message: string = "The following Courses cannot be linked to this Curriculum as they are associated with an incompatible eQMS Scope: CourseNumbers";
    public static readonly Curriculum_FailureToUpdate: string = "The update operation was not successfull";
    public static readonly Curriculum_WarningMessageForSameStatusTrainingItem: string = "The following Training Items have not been updated because they are already in the selected Status: TrainingItemCodes"
    public static readonly Curriculum_WarningMessageForRemovedStatusTrainingItem : string = 
    "The following Training Items have not been updated because they are in Status Removed:TrainingItemCodes";
    public static readonly Curriculum_WarningMessageForSameCoreOrElectiveTrainingItem : string = 
    "The following Training Items have not been updated because they are already in the selected Core/Elective: TrainingItemCodes"
    public static readonly Selected_TrainingItemGroupscopes_Not_Matching_Error_Message: string = "At least one of the selected Training Item Groups cannot be linked to this Curriculum as they are associated with an incompatible eQMS Scope: TrainingItemGroupNumbers";
    public static readonly Curriculum_UnableToFetchAuth_ErrorMessage: string = 'Unable to get the Curriclum Roles';

    //Information Message 
    public static readonly ShowAll_InformationIconMessage : string = "By default the Training Items with Status Removed are not displayed. Check this check box to display them."

    //Toaster Messages
    public static readonly Curriculum_UpdatedMessage: string = 'Curriculum has been updated'
    public static readonly Curriculum_CreatedMessage : string = 'Curriculum has been created'
    public static readonly TrainingItems_StatusUpdatedMessage : string = 'The selected training item(s) have been updated to StatusName status'
    public static readonly TrainingItems_CoreOrElectiveUpdatedMessage : string = 'The selected training item(s) have been updated to CoreOrElective'

    //Warning Messages
    public static readonly Curriculum_Warning_TrainingItemAlreadyPresentMessage: string = 'At least one Training Item in the Group already belongs to the Curriculum and has not been added: TrainingItems'
    public static readonly Curriculum_Warning_TrainingItemMovedToActiveMessage: string = 'The following Training Items are already in the Curriculum and have been marked Active: TrainingItems'

    // features
    public static readonly Curriculum_Feature: string = 'curriculum';

    public static readonly Curriculum_ErrorWhileFetchingTrainingItems: string = 'The following items were not migrated to this curriculum:';
    public static readonly CurriculumDocumentDetails : string = 'Curriculum Document Details'
    public static readonly CurriculumCourseDetails : string = 'Curriculum Course Details'

    public static readonly Curriculum_UnAssign_Training_Item_Group_Btn_Label: string = 'Unassign Training Item Group';
    public static readonly Curriculum_UnAssign_Training_Item_Group_Header_Text: string = 'Unassign Training Item Group';
    public static readonly Curriculum_UnAssign_Training_Item_Group_Success_Message:string = "Selected Training Item Group(s) have been unassigned successfully from the Curriculum.";
    public static readonly Curriculum_UnAssign_Training_Item_Group_Error_Message:string = "A technical error occurred and Selected Training Item Group(s) were not unassigned from the Curriculum. Please retry and if this error persists, report it to your support contact.";
    public static readonly Curriculum_Fetch_Training_Item_Group_Error_Message:string = "A technical error occurred while fetching Training Item Group(s) referenced in curriculum. Please retry and if this error persists, report it to your support contact.";

}
